<template>
  <div>
    <!-- ヘッダ -->
    <comMaintHeaderAuth :propScreenTitle="screenTitle" :propSrcScreenId="screenId" :propMenuInfo1="username" :propMenuInfo2="deptname"></comMaintHeaderAuth>
    <v-main>
      <v-container fluid>
        <!-- メッセージエリア -->
        <v-alert border="bottom" colored-border type="info" elevation="2">
          {{ messageArea }}
        </v-alert>
        <!-- 検索条件 -->
        <div class="group-box">
          <span class="box-title">検索条件</span>

          <v-row dense>
            <v-col cols="1" class="d-flex align-center justify-end">
              <v-sheet width="100%" class="pa-0">
                <label class="tbl-lbl-blcok required">申込日 </label>
              </v-sheet>
            </v-col>
            <v-col cols="2" class="mr-0 search-date">
              <v-menu
                v-model="menuSrtReqDateFlg"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="srtReqDate"
                    label="開始日"
                    persistent-hint
                    clearable
                    prepend-icon="mdi-calendar"
                    readonly
                    single-line
                    v-bind="attrs"
                    v-on="on"
                    
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="srtReqDate"
                  @input="menuSrtReqDateFlg = false"
                ></v-date-picker>
              </v-menu>
              
            </v-col>
            <v-col cols="1" class="d-flex align-center justify-start" style="max-width: 20px">
              <span >～</span>
            </v-col>
            <v-col cols="2" class="search-date">
              <v-menu
                v-model="menuEndReqDateFlg"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="endReqDate"
                    label="終了日"
                    persistent-hint
                    clearable
                    prepend-icon="mdi-calendar"
                    readonly
                    single-line
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="endReqDate"
                  @input="menuEndReqDateFlg = false"
                ></v-date-picker>
              </v-menu>
            </v-col>

            <v-col cols="1" class="d-flex align-center justify-end ">
              プラン
            </v-col>
            <v-col cols="5" class="d-flex align-center">
              <v-select
                v-model="selectPlans"

                :items="plans"
                item-text="name"
                item-value="cd"
                multiple
                label="複数選択できます"
                clearable
                return-object
              ></v-select>
            </v-col>
            <!-- <v-col cols="3"> </v-col> -->
          </v-row>

          <v-row dense>
            <v-col cols="1" class="d-flex align-center justify-start">
              氏名
            </v-col>
            <v-col cols="2">
              <v-text-field
                v-model="srchCndName"
                label="フリガナまたは漢字の前方一致"
                clearable
              ></v-text-field>
            </v-col>
            <v-col cols="1" class="d-flex align-center justify-end">
              会社名
            </v-col>
            <v-col cols="2">
              <v-text-field
                v-model="srchCndCompanyName"
                label="フリガナまたは漢字の前方一致"
                clearable
              ></v-text-field>
            </v-col>
            <v-col cols="1" class="d-flex align-center justify-end">進捗</v-col>
            <v-col cols="3">
              <v-select
                v-model="selectProgress"

                :items="progress"
                item-text="name"
                item-value="cd"
                multiple
                label="複数選択できます"
                clearable
                return-object
              ></v-select>
            </v-col>
            <v-col cols="2" class="d-flex align-start justify-end">
              <v-btn
                x-large
                color="indigo darken-1"
                dark
                min-width="120px"
                @click="search()"
                >{{ $t("LCM001") }}</v-btn
              >
            </v-col>
          </v-row>
        </div>

        <!-- 検索結果一覧 -->
        <v-data-table 
          :headers="headers" 
          :items="desserts"
          item-key="no"
          :items-per-page="10"
          show-expand 
          
          class="v-data-table elevation-1 v-dtbl-md-1"
          :no-data-text="$t('webmsg.common.datatblenodata')"
          >

          <template v-slot:[`item.verifyStatus`]="{ item }">
            <template v-if="item.verifyStatus.name == '未確認'">
              <v-btn medium color="red" :disabled="item.unconfirmedInactive" class="white--text" min-width="80px" elevation="5" @click="requestVerify(item.requestNo, item.managerName, item.managerNameKana, item.mailAddress)">{{item.verifyStatus.name}}</v-btn>
            </template>
            <template v-else-if="item.verifyStatus.name != null && item.verifyStatus.name != ''">
            <v-chip outlined :color="item.verifyStatus.color" :text-color="item.verifyStatus.color">
              <v-icon left>{{ item.verifyStatus.icon }}</v-icon>
              {{ item.verifyStatus.name }}
            </v-chip>
            </template>
          </template>

          <template v-slot:[`item.managerName`]="{ item }">
            {{ item.managerNameKana }}
            <br/>
            {{ item.managerName }}
          </template>

          <template v-slot:[`item.progress`]="{ item }">
            <v-chip :class="item.progress.color" dark v-if="item.progress.name != null && item.progress.name != ''">
              <v-icon left>{{ item.progress.icon }}</v-icon>
              {{ item.progress.name }}
            </v-chip>
          </template>

          <template v-slot:[`item.company`]="{ item }">
            {{ item.company }}
            <br/>
            {{ item.name }}
          </template>

          <template v-slot:[`item.plan`]="{ item }">
            {{ item.basePlanName }}
            <span v-if="item.optionPlanName != null">
              <br/>
              {{ item.optionPlanName }}
            </span>
            <span v-else>
              <br/>
            </span>
          </template>

          <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers.length" style="background-color: #FFE0B2 !important;" >
              <span v-html="item.comment"></span>
            </td>
          </template>
          <!-- <template v-slot:[`item.confirmBtnFlg`]="{ item }"> -->
            <!-- <span v-if="item.confirmBtnFlg"> -->
              <!-- <v-btn small color="indigo darken-1" dark  min-width="80px" @click="dispConfirmView(item.requestId)">詳細</v-btn> -->
              <!-- <v-btn small color="warning" dark  min-width="80px" @click="dispConfirmView(item.requestId)">詳細</v-btn> -->
            <!-- </span> -->
          <!-- </template> -->
           <template v-slot:[`item.detail`]="{ item }">
              <v-btn small color="indigo darken-1" dark min-width="80px" @click="dispConfirmView(item.requestNo)">{{ $t("LCM005") }}</v-btn>
          </template>
          <!-- <template v-slot:[`item.mailAddress`]="{ item }">
            <span v-show='false'>
            {{ item.mailAddress }}
            </span>
          </template> -->
        </v-data-table>
      </v-container>
    </v-main>
    <comMessage :msg="dlgMsg.msg" :isOpen="dlgMsg.isOpen" :doYes="dlgMsg.doYes"/>
    <comMainteVerifyRequest :msg="dlgVfReq.msg" :isOpen="dlgVfReq.isOpen" :requestNo="dlgVfReq.requestNo" :managerNameKana="dlgVfReq.managerNameKana" :managerName="dlgVfReq.managerName" :mailAddress="dlgVfReq.mailAddress" :doYes="dlgVfReq.doYes" :doNo="dlgVfReq.doNo"/>
  </div>
</template>

<script>
import Constants from "../common/constants";
import Utils from "../common/utils";
export default {
  name: "MainteRequestListSearch",
  data() {
    return {
      username: "",
      deptname: "",
      screenTitle: " [メンテ] 申込情報一覧検索",
      screenId: "MTR100",
      messageArea: "",
      srtReqDate: new Date().toISOString().substr(0, 10),
      endReqDate: new Date().toISOString().substr(0, 10),
      menuSrtReqDateFlg: false,
      menuEndReqDateFlg: false,
      plans: [{ cd: "", name: "" }],
      progress: [{ cd: "", name: "" }],
      verifyStatusKbnMstList: [],
      headers: [
          { text: "No", align: "start", value: "no", width: "5%" },
          { text: '申込番号', align: 'center', sortable: true, value: 'requestNo', width: "12%" },
          { text: '申込日付', align: 'center', sortable: true, value: 'requesdate', width: "12%" },
          { text: '本人確認', align: 'center', sortable: true, value: 'verifyStatus', width: "5%"},
          { text: '担当者名', align: 'start', sortable: true, value: 'managerName', width: "14%" },
          { text: '会社名・氏名', align: 'start', sortable: true, value: 'company', width: "20%" },
          { text: 'プラン', align: 'start', sortable: true, value: 'plan', width: "20%" },
          { text: '進捗', align: 'center', sortable: true, value: 'progress', width: "5%" },
          { text: 'コメント', align: 'start', sortable: true, value: 'data-table-expand', width: "5%" },
          { text: '詳細', align: 'center', sortable: false, value: 'detail', width: "5%" },
          { text: 'メールアドレス', align: ' d-none', sortable: false, value: 'mailAddress', width: "5%" },
      ],
      desserts: [],
      srchCndName: "",
      srchCndCompanyName: "",
      selectPlans: [],
      selectProgress: [],
      dlgMsg: {
        msg: "",
        isOpen: false,
        doYes: () => {
          this.dlgMsg.isOpen = false;
        },
      },

      dlgVfReq: {
        msg: this.$i18n.t('msg.wrn.mb020'),
        isOpen: false,
        requestNo: "",
        managerNameKana: "",
        managerName: "",
        mailAddress:"",
        sex: "",
        birthDate: "",
        doYes: () => {
          // 本人確認依頼
          this.dlgVfReq.isOpen = false;
          // 再検索
          this.search();
        },
        doNo: () => {
          this.dlgVfReq.isOpen = false;
        },
      },
    };
  },
  created() {
    this.initialize();
  },
  beforeRouteLeave(to, from, next) {
    // 画面用データストア破棄
    if (to.name != 'MTR200') {
      this.$store.commit("mainteRequestListSearch/resetState");
    }
    next();
  },
  methods: {

    /*
    * 未確認ボタン押下（本人確認依頼）
    */
    requestVerify: function(requestNo, name, nameKana, mailAddress) {
      this.dlgVfReq.requestNo = requestNo;
      this.dlgVfReq.managerName = name;
      this.dlgVfReq.managerNameKana = nameKana;
      this.dlgVfReq.mailAddress = mailAddress;
      this.dlgVfReq.isOpen = true;
    },

    /*
     * 初期表示
     */
    initialize() {
      this.setAuthUserInfo();
      this.getPullDown();
      // 画面説明メッセージ
      this.messageArea = this.$i18n.t('webmsg.mtr100.area');
      // 再検索
      this.reSearch();
    },
    setAuthUserInfo : function() {      
      let authInfo = this.setMainteLoginInfoMixin();
      this.username = authInfo['username'];
      this.deptname = authInfo['deptname'];
    },
    /*
     * プルダウン情報取得
     */
    getPullDown : async function() {
      // ログインサービス呼び出し
      let responseData = null;
      let apiurl = Constants.URL_API_MTR100G01;
      let accessToken = this.$store.getters["authcUser/getAccessToken"];
      try {
        let response = await this.$axios.get(apiurl, 
            {
              headers: {"content-type": "application/json", "X-AUTH-TOKEN": "Bearer " + accessToken}, 
              responseType: "json",
            });
        responseData = response.data
        this.plans = responseData.data.planList;
        this.progress = responseData.data.progressList;
      } catch(error) {
          this.dlgMsg.msg = this.$i18n.t('msg.err.cm110', ['プルダウン情報の取得']);
          this.dlgMsg.isOpen = true;
      } 
    },
    /**
     * 「検索」ボタン押下
     */
    search: async function() {
      this.desserts = [];
       // 申込情報一覧検索サービス呼び出し
      let responseData = null;
      let apiErrorInfo = null;

      try {
        let apiurl = Constants.URL_API_MTR100P01;
        let accessToken = this.$store.getters["authcUser/getAccessToken"];
        // 入力データ
        let searchCondition = this.requestInfoListSearchData();
        let data = JSON.stringify(searchCondition);
        // API呼出
        let response = await this.$axios.post(apiurl,data,
            {
              headers: {"content-type": "application/json", "X-AUTH-TOKEN": "Bearer " + accessToken}, 
              responseType: "json",
            });
            console.log(response);
        responseData = response.data
        this.displyRequestInfoList(responseData);
        this.dispProgress();
        // 画面用データストア(検索条件)登録
        this.$store.dispatch("mainteRequestListSearch/setSearchCondition", searchCondition);
      } catch(error) {
          apiErrorInfo = error;
      } 
      // 完了メッセージ表示
      this.showDialogMsgAfterAPICall(this.dlgMsg, apiErrorInfo, responseData);

    },
    /**
     * 再検索処理
     */
    reSearch: function() {
      // 画面用データストア(検索条件)取得
      let searchCondition = this.$store.getters["mainteRequestListSearch/getSearchCondition"];
      if (searchCondition == null || !Object.keys(searchCondition).length || typeof searchCondition['requestDateStart'] === "undefined") {
        return;
      }
      // 検索条件復元
      this.srtReqDate = searchCondition['requestDateStart'];
      this.endReqDate = searchCondition['requestDateEnd'];
      this.srchCndName = searchCondition['name'];
      this.srchCndCompanyName = searchCondition['companyName'];
      this.selectPlans = searchCondition['selectPlan'];
      this.selectProgress = searchCondition['selectPlogress'];
      // 再検索
      this.search();
    },
   /*
    * 検索用リクエストデータ生成
    */
    requestInfoListSearchData : function() {
      let reqData = {};
      reqData['requestDateStart'] = this.srtReqDate;
      reqData['requestDateEnd'] = this.endReqDate;
      reqData['name'] = this.srchCndName;
      reqData['companyName'] = this.srchCndCompanyName;
      reqData['selectPlan'] = this.selectPlans;
      reqData['selectPlogress'] = this.selectProgress;
      return reqData;
    },

    /*
    * 申込情報一覧表示
    */
    displyRequestInfoList : function(responseData) {
      this.desserts = new Array();
      if (responseData.data == null) {
        return;
      }
      let searchResultList = responseData.data.requestInfoSearchResultDtoList;
      if (Utils.isEmptyArry(searchResultList)) {
        return;
      } 
      let request;
      for (const value of searchResultList) {
        request = {};
        request['no'] = value.displayNo ;
        request['requestNo'] = value.displayRequestNo;
        request['requesdate'] = value.requestDate;
        request['company'] = value.companyName;
        request['name'] = value.name;
        request['managerName'] = value.managerName;
        request['managerNameKana'] = value.managerNameKana;
        request['basePlanName'] = value.displayBasePlanName;
        request['optionPlanName'] = value.displayOptionPlanName; 
        request['progress'] = {cd: value.progress, name: ""};
        request['comment'] = value.comment; 
        request['verifyStatus'] = {cd: value.verifyStatusClass, name: value.verifyStatusName};
        request['unconfirmedInactive'] = value.unconfirmedInactive;
        request['mailAddress'] = value.mailAddress;
        this.desserts.push(request);
      }
    },

    /*
    * 進捗区分画面表示
    */
    dispProgress : function() {
      this.progressKbnMstList = this.$store.getters["master/getProgressKbnList"];
      this.verifyStatusKbnMstList = this.$store.getters["master/getVerifyStatusKbnList"];
      if (this.desserts == null || this.progressKbnMstList == null || this.verifyStatusKbnMstList == null) {
           return;
      }
      this.desserts.forEach((dessert, index, arr) => {
        if(dessert.progress.cd != null && dessert.progress.cd  != ''){
            let progresData = this.getProgressNm(dessert.progress.cd );
            if (progresData != null) {
              arr[index].progress.name = progresData.nameAbbr;
              arr[index].progress.color = progresData.value2;
              arr[index].progress.icon = progresData.value3;
            }
        } 
        if (dessert.verifyStatus.cd != null && dessert.verifyStatus.cd != '') {
          let verifyStatusData = this.getVerifyStatusNm(dessert.verifyStatus.cd);
          if (verifyStatusData != null) {
            arr[index].verifyStatus.name = verifyStatusData.nameAbbr;
            arr[index].verifyStatus.color = verifyStatusData.value2;
            arr[index].verifyStatus.icon = verifyStatusData.value3;
          }
        } else {
            arr[index].verifyStatus.name = "未確認";
            arr[index].verifyStatus.color = "red";
            arr[index].verifyStatus.icon = "mdi-account-alert-outline";
        }  
      });

    },

     /**
     * 区分値（進捗）設定
     */
    getProgressNm(ProgressCd) {
      let retVal = "";
      let searchArry = "";
      if (ProgressCd != "") {
        searchArry = this.progressKbnMstList.find((v) => v.value1 === ProgressCd);
      }
      if (searchArry != null) {
        retVal = searchArry;
      }
      return retVal;
    },
    getVerifyStatusNm(verifyStatusCd) {
      let retVal = "";
      let searchArry = "";
      if (verifyStatusCd != "") {
        searchArry = this.verifyStatusKbnMstList.find((v) => v.value1 === verifyStatusCd);
      }
      if (searchArry != null) {
        retVal = searchArry;
      }
      return retVal;
    },
    /*
    * 完了メッセージ表示
    */
    showDialogMsgAfterAPICall : function(dialog, apiErrorInfo, responseData) {
      let hasError = true;
      // APIコール異常
      if (responseData == null || apiErrorInfo != null) {
        dialog.msg = this.$i18n.t('msg.err.cm100', ['申込情報一覧']);
        dialog.isOpen = true;
        // this.desserts.push({});
        return hasError;
      }
      // API処理異常
      if (responseData.statusCd === 500) {
        let errorList = responseData.errorList;
        if (errorList != null && errorList.length > 0) {
          dialog.msg = Utils.createMsgViewStringForErrList(errorList);
          dialog.isOpen = true;
          // this.desserts.push({});
          return hasError;
        }else{
          dialog.msg = responseData.message ;
          dialog.isOpen = true;
          // this.desserts.push({});
         return hasError;
        }
      }
    },

   /**
     * 詳細画面遷移
     */
    dispConfirmView(selectedRequestNo) {
        this.$router.push(this.$router.resolve({ name: "MTR200", params: {requestNo: selectedRequestNo, srcScreenId: this.screenId} }).href);
    },
  },
};
</script>

<style scoped>
.group-box {
  position: relative;
  margin: 1.3em 0;  padding: 0.3em 2em;
  border: solid 2px #141414;
  border-radius: 8px;
}
.group-box .box-title {
  position: absolute;
  display: inline-block;
  top: -13px;
  left: 10px;
  padding: 0 9px;
  line-height: 1;
  font-size: 18px;
  background: #fff;
  color: #0b0c0c;
  font-weight: bold;
}
.group-box p {
  margin: 0;
  padding: 0;
}
.search-date {
  max-width: 160px;
}
</style>
